import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import classes from './MarkdownView.module.css';

const markdownComponents = {
  table: ({ children }) => (
    <div className={classes.TableWrapper}>
      <table className={classes.Table}>{children}</table>
    </div>
  ),
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

export default function MarkdownView({ children, className = '' }) {
  if (!children) {
    return null;
  }

  return (
    <div className={`${classes.Root} ${className}`.trim()} dir="auto">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
